import React from 'react';
import NeighborhoodAccordion from './NeighborhoodAccordion';
import { Neighborhood } from 'apolloClient/types';

interface ResultAccordionProps {
  countyName: string;
  cities: {
    cityName: string;
    neighborhoods: Neighborhood[];
  }[];
  onLinkClick?: () => void;
}

const ResultAccordion: React.FC<ResultAccordionProps> = ({
  countyName,
  cities,
  onLinkClick = () => {},
}) => {
  return (
    <NeighborhoodAccordion
      countyName={countyName}
      cities={cities}
      defaultExpanded
      onLinkClick={onLinkClick}
    />
  );
};

export default ResultAccordion;
